import { useScrollReveal } from '../../../hooks/useScrollReveal';

const ContactHeader = () => {
  const { ref: badgeRef, isVisible: badgeVisible } = useScrollReveal();
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal();
  const { ref: descRef, isVisible: descVisible } = useScrollReveal();

  return (
    <div className="relative bg-gradient-to-br from-[#0D1B3E] via-[#1A2B5E] to-black text-white py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#C9A84C] rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#1A9B8C] rounded-full blur-3xl animate-float-delayed"></div>
      </div>
      
      <div className="relative max-w-[1400px] mx-auto px-6">
        <div className="text-center">
          <div 
            ref={badgeRef}
            className={`inline-flex items-center space-x-2 bg-[#C9A84C]/20 backdrop-blur-sm px-6 py-2 rounded-full mb-6 ${
              badgeVisible ? 'animate-slide-up' : 'opacity-0'
            }`}
          >
            <i className="ri-mail-line text-[#C9A84C] text-xl"></i>
            <span className="text-sm font-medium text-[#C9A84C]">Bizimle İletişime Geçin</span>
          </div>
          
          <h1 
            ref={titleRef}
            className={`text-5xl md:text-6xl font-bold mb-6 ${
              titleVisible ? 'animate-slide-up animate-stagger-1' : 'opacity-0'
            }`}
          >
            İletişim
          </h1>
          
          <p 
            ref={descRef}
            className={`text-xl text-white/80 max-w-3xl mx-auto leading-relaxed ${
              descVisible ? 'animate-slide-up animate-stagger-2' : 'opacity-0'
            }`}
          >
            İstanbul Kongresi hakkında sorularınız için bizimle iletişime geçebilir, bilimsel sekreterya ve organizasyon ekibimize ulaşabilirsiniz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactHeader;